import { render, staticRenderFns } from "./payment-board.vue?vue&type=template&id=2bea5c4d&scoped=true&"
import script from "./payment-board.vue?vue&type=script&lang=ts&"
export * from "./payment-board.vue?vue&type=script&lang=ts&"
import style0 from "./payment-board.vue?vue&type=style&index=0&id=2bea5c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bea5c4d",
  null
  
)

export default component.exports